function getLangStorage(keyName) {
  let value = window.localStorage.getItem(keyName);
  return value;
}

export default getLangStorage;
